import { RouteObject } from "react-router-dom";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import reportsRoutesList from "./routesList";
import { lazy } from "react";
import DailyInvoiceReport from "./CollectionReports/DailyInvoiceReport";
import MonthlyInvoiceReport from "./CollectionReports/MonthlyInvoiceReport";
import DoctorWiseBillingReport from "./CollectionReports/DoctorWiseBillingReport";
import EncounterWiseCollectionReport from "./CollectionReports/EncounterWiseCollectionReport";
import CptGroupwiseReport from "./CollectionReports/CPTGroupwiseReport";
import InsuranceClaimSummary from "./claimReports/insuranceClaimSummary";
import InsuranceWiseClaimReport from "./claimReports/insuranceWiseClaimReport";
import InsuranceClaimDetailsReport from "./claimReports/insuranceClaimDetailsReport";
import Loader from "../utilis/component/SkeletonLoading/Loader";
import ReconcilationReport from "./ReconciliationReport";
const AgingReport = lazy(()=>import("./AgingReport"));
const AgingReportNew = lazy(()=>import("./AgingReportNew"));
const PatientReport =lazy(()=>import("./PatientListReport"))
const InsuranceWiseOutStandingReport = lazy(()=>import("./InsuranceWiseOutStandingReport/index"))
const DailyRevenueReport = lazy(()=>import("./DailyRevenueReport"))
const AppointmentReport = lazy(()=>import("./appointmentReport/index"))
const BillwiseReport = lazy(()=>import("./DetailedReports/BillwiseReport"))
const PatientwiseReport = lazy(()=>import("./DetailedReports/PatientwiseReport"))
const EncounterListReport = lazy(()=>import("./encouterListReport"))
const CodificationStatusReport = lazy(()=>import("./codificationStatusReport"))
const PaymentTypeWiseReport = lazy(()=>import("./DetailedReports/paymentTypeWiseReport"))
const DepartmentWiseReport = lazy(()=>import("./DetailedReports/DepartmentWise"))
const UserWiseReport = lazy(()=>import("./DetailedReports/UserwiseReport"))
const ExpenseReport = lazy(()=>import("./expenseReports"))
const reportsRoutes: RouteObject[] = [
    {
      path: `${reportsRoutesList.insuranceWiseOutStandingReport}`,
      element: (
        <PrivateRoute>
          <Loader>
             <InsuranceWiseOutStandingReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.dailyRevenueReport}`,
      element: (
        <PrivateRoute>
          <Loader>
             <DailyRevenueReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.patientListReport}`,
      element: (
        <PrivateRoute>
          <Loader>
             <PatientReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.appointmentReport}`,
      element: (
        <PrivateRoute>
          <Loader>
             <AppointmentReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.encounterListReport}`,
      element: (
        <PrivateRoute>
          <Loader>
             <EncounterListReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.billwisereport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <BillwiseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.patientWiseReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <PatientwiseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.agingReportOld}`,
      element: (
        <PrivateRoute>
          <Loader>
            <AgingReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.agingReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <AgingReportNew/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.dailyInvoiceReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <DailyInvoiceReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.monthlyInvoiceReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <MonthlyInvoiceReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.codificationReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <CodificationStatusReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.doctotWiseBillingReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <DoctorWiseBillingReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.encounterWiseCollectionReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <EncounterWiseCollectionReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.payemntTypeWiseReport}`,
      element: (
        <PrivateRoute>
          <Loader>
             <PaymentTypeWiseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.departmentWiseReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <DepartmentWiseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.userwiseReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <UserWiseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.cptGroupWiseReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <CptGroupwiseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.expenseReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <ExpenseReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.insuranceClaimSummaryReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <InsuranceClaimSummary/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.insuranceWiseClaimReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <InsuranceWiseClaimReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
    {
      path: `${reportsRoutesList.insuranceClaimDetailsReport}`,
      element: (
        <PrivateRoute>
          <Loader>
           <InsuranceClaimDetailsReport/>
          </Loader>
        </PrivateRoute>
      ),
    },

    {
      path: `${reportsRoutesList.reconcilationReport}`,
      element: (
        <PrivateRoute>
          <Loader>
            <ReconcilationReport/>
          </Loader>
        </PrivateRoute>
      ),
    },
  ];
  export default reportsRoutes